import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as english } from './i18n/en';
import { locale as spanish } from './i18n/es';
import { ActivatedRoute, Router } from '@angular/router';
import { Proveedor, Cliente, Cookies } from 'app/models/data.model';
import { DataManagement } from 'app/services/dataManagement';
import { UtilityProvider } from 'app/providers/utility/utility';
import { GlobalService } from 'app/services/globalService';

@Component({
    selector: 'auto-login',
    templateUrl: './auto-login.component.html',
    styleUrls: ['./auto-login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class AutoLoginComponent implements OnInit {
    proveedor: Proveedor;
    cliente: Cliente;

    idProveedor: string;
    idCliente: string;
    cookies: Cookies;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private translationLoader: FuseTranslationLoaderService,
        private route: ActivatedRoute,
        private router: Router,
        private dm: DataManagement,
        private utils: UtilityProvider,
        private globalService: GlobalService,
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        this.translationLoader.loadTranslations(english, spanish);
        this.idProveedor = this.route.snapshot.paramMap.get('idProveedor');
        this.idCliente = this.route.snapshot.paramMap.get('idCliente');
        this.cookies = new Cookies();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit() {
        console.log('On init')
        this.route.queryParams.subscribe( async params => {
            console.log('pa: ', params)
            if (params.idclient) {
                console.log('viene cliente: ', params.idclient)
            } else {
                 try {
            if (this.idProveedor && this.idCliente) {
                let resAutoLoginClient = await this.dm.autoLoginClient(this.idProveedor, this.idCliente);
                //console.log(resAutoLoginClient)
                if (!resAutoLoginClient) {
                    await this.utils.openDialog(this.utils.WARNING, "Operación no disponible en estos momentos. Inténtelo de nuevo más tarde.", false, false);
                } else if (resAutoLoginClient.status == 'bad') {
                    await this.utils.openDialog(this.utils.WARNING, "No se ha podido iniciar sesión, vuelva a intentarlo.", false, false);
                } else if (resAutoLoginClient.status == 'ok') {
                    this.cookies.cliente = resAutoLoginClient.cliente._id;
                    this.globalService.iniciarSesion(resAutoLoginClient.cliente, this.cookies);
                    setTimeout(() => {
                        // this.loading = false;
                        this.router.navigateByUrl("/apps/dashboards/analytics");
                    }, 1000);
                }
            }
        } catch (error) {
            //console.log(error);
            await this.utils.openDialog(this.utils.WARNING, "Operación no disponible en estos momentos. Inténtelo de nuevo más tarde.", false, false);
        }
            }
        });
       
    }
}
